import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { usePendingUser } from './hooks';
import { convertToPresentationProps } from './logics';
import { PendingUserPresentation } from './presentations';

export const PendingUserList = () => {
  const {
    state: {
      users,
      sortParams,
      keyword,
      currentPage,
      totalPage,
      totalCount,
      totalPendingCount,
      partnerFeatureFlagData,
    },
    actions: {
      handleKeywordChange,
      handleSearch,
      handlePageChange,
      handleOutputCsv,
      handleHeaderSort,
      onClickRow,
      onClickSendReminder,
      onOpenBulkConfirm,
    },
  } = usePendingUser();

  const { pendingUsers, pendingRate, disableRowNavigation } = convertToPresentationProps({
    users,
    sortParams,
    totalCount,
    totalPendingCount,
    partnerFeatureFlagData,
  });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount: totalPendingCount,
    rows: pendingUsers,
    onPageChange: handlePageChange,
  });

  return (
    <PendingUserPresentation
      pendingRate={pendingRate}
      pendingUsers={pendingUsers}
      keyword={keyword}
      totalCount={totalCount}
      totalPendingCount={totalPendingCount}
      pagerProps={pagerProps}
      handleKeywordChange={handleKeywordChange}
      handleSearch={handleSearch}
      handleOutputCsv={handleOutputCsv}
      handleHeaderSort={handleHeaderSort}
      onClickRow={disableRowNavigation ? undefined : onClickRow}
      onClickSendReminder={onClickSendReminder}
      onOpenBulkConfirm={onOpenBulkConfirm}
    />
  );
};
